import React from 'react';
import {Card} from 'react-bootstrap';

function STCCardFooter(props){

    return(
        <Card.Footer
            className={props.className}
            style={props.style}
            onClick={props.onClick}

            as={props.as}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Card.Footer>
    )

}
export default STCCardFooter;